import { render, staticRenderFns } from "./SidebarRight.vue?vue&type=template&id=0c383b3c&scoped=true"
import script from "./SidebarRight.vue?vue&type=script&lang=js"
export * from "./SidebarRight.vue?vue&type=script&lang=js"
import style0 from "./SidebarRight.vue?vue&type=style&index=0&id=0c383b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c383b3c",
  null
  
)

export default component.exports